import { ZoomService } from '@src/services/ZoomService';
import { useStore } from '@src/stores-v2/StoreContext';
import { useMemo } from 'react';

export function useZoomService(): ZoomService {
  const { userIdentityStore } = useStore();
  const apiUrl = process.env.REACT_APP_API_URL || '';
  return useMemo(
    () =>
      new ZoomService(
        apiUrl,
        async () => (await userIdentityStore.getFreshToken()) || undefined,
      ),
    [apiUrl, userIdentityStore],
  );
}
